import { useState } from 'react'
import { useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { selectIsEnterprise } from '../store'

import { Stack } from '@mui/material'
import { AppleLoginButton, FacebookLoginButton, GoogleLoginButton } from './Auth0'
import { Config } from '../types/Config'
import { Can, AuthUserPermission } from '../index'
import { DirectLoginForm } from './'
import { parse } from 'query-string'
import { pick } from 'ramda'

export type Auth0Props = {
  AUTH0_DOMAIN: string
  AUTH0_CLIENT_ID: string
  homepage: string
}

export const AuthForm = () => {
  const [hideSSO, setHideSSO] = useState(false)
  const isEnterprise = useSelector(selectIsEnterprise)
  const location = useLocation()
  const parseParams = parse(location.search)

  const AUTH0_DOMAIN = Config.get('AUTH0_DOMAIN')
  const AUTH0_CLIENT_ID = Config.get('AUTH0_CLIENT_ID')
  const homepage = Config.get('homepage')

  const handleValidationStep = (state: boolean) => setHideSSO(state)

  return (
    <DirectLoginForm
      onValidationStep={handleValidationStep}
      pushForgotPassword={() => null}
      {...pick(['code', 'formAuthToken', 'username'], parseParams)}
    >
      {!hideSSO && !isEnterprise && (
        <Can useAny={AuthUserPermission.ALLOW_REGISTRATION}>
          <>
            <Stack spacing={2}>
              <GoogleLoginButton
                AUTH0_CLIENT_ID={AUTH0_CLIENT_ID}
                AUTH0_DOMAIN={AUTH0_DOMAIN}
                homepage={homepage}
              />
              <AppleLoginButton
                AUTH0_CLIENT_ID={AUTH0_CLIENT_ID}
                AUTH0_DOMAIN={AUTH0_DOMAIN}
                homepage={homepage}
              />
              <FacebookLoginButton
                AUTH0_CLIENT_ID={AUTH0_CLIENT_ID}
                AUTH0_DOMAIN={AUTH0_DOMAIN}
                homepage={homepage}
              />
            </Stack>
          </>
        </Can>
      )}
    </DirectLoginForm>
  )
}
